import { MessageStates } from 'containers/MessageBox';
import { ExportToExcelRequestAction } from '../types';
import { saveAs } from 'file-saver';
import { call, put } from 'redux-saga/effects';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { exportToExcelRequest } from '../api';
import { exportToExcelDone } from '../actions';
import i18n from 'i18next';

export function* exportToExcelRequestSaga(action: ExportToExcelRequestAction) {
  const { reportId, mappingId, fileName, boxValues } = action.payload;

  try {
    const response = yield call(
      exportToExcelRequest,
      reportId,
      mappingId,
      boxValues
    );

    if (response) {
      const blob = yield call([response, 'blob']);
      saveAs(blob, fileName);
    }
  } catch (error) {
    const message: MessageData = {
      title: i18n.t('common.error'),
      description: i18n.t('notifications.there-was-an-unexpected-error-while-trying-to-download-a-file-if'),
      type: MessageStates.ERROR,
    };
    yield put(turnMessageOn(message));
  }

  yield put(exportToExcelDone());
}
